import "./NumbersList.css";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import React, { useState, useEffect } from "react";

const NumbersList = ({ searchTerm }) => {
  const [assignedNumbers, setAssignedNumbers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth")) || { user: {} };
    setAssignedNumbers(auth?.user?.assignNumber || []);
  }, []);

  const filteredNumbers = assignedNumbers.filter((number) =>
    number.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredNumbers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedNumbers = filteredNumbers.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  return (
    <>
      <div className="NumberListBox">
        <div className="numberListHeader">
          <div className="numberListItem">
            <div className="phoneNumberBox">
              <p>Phone Number</p>
            </div>
            <div className="timeReceivedBox">
              <p>Renewal Date</p>
            </div>
            <div className="messageBox">
              <p>Status</p>
            </div>
          </div>
        </div>

        <div className="messageListBody">
          {paginatedNumbers.map((number, index) => (
            <div className="messageListItem" key={index}>
              <div className="phoneNumberBox">
                <p>{number}</p>
              </div>
              <div className="timeReceivedBox">
                <p>{new Date().toISOString().split("T")[0]}</p>
              </div>
              <div className="messageBox">
                <p className="text-success">Active</p>
              </div>
            </div>
          ))}
        </div>

        <div className="paginationControls">
          <button
            type="button"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            <FaArrowLeftLong size={24} />
          </button>
          <span className="pageIndicator">
            Page {currentPage} of {totalPages}
          </span>
          <button
            type="button"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            <FaArrowRightLong size={24} />
          </button>
        </div>
      </div>
    </>
  );
};

export default NumbersList;
